import React, { useEffect, useState, useRef } from "react";
import { QuotationService } from "../../../../Services/Manage/QuotationService";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  DatePicker,
  Row,
  Col,
  Form,
  Button,
  Typography,
  Input,
  Space,
  Modal,
  Popconfirm,
} from "antd";
import ListEqData from "../ListEqData";
import {
  ArrowLeftOutlined,
  MailOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import { UserService } from "../../../../Services/Manage/UserService";
import useMessage from "antd/es/message/useMessage";
import EditQuotationData from "./EditQuotationData";
import dayjs from "dayjs";
import { EnquiryService } from "../../../../Services/Manage/EnquiryService";
import CustomerDetails from "../../Enquiry/CustomerDetails";

const EditViewQuotation = () => {
  const { TextArea } = Input;
  const editQuotationRef = useRef(null);
  const primaryColor = "rgba(11, 93, 148, 0.95)";

  const location = useLocation();
  const navigate = useNavigate();
  const qu_no = location.state?.qu_no;

  const [form] = Form.useForm();
  const [customerForm] = Form.useForm();
  const [message, msgConxt] = useMessage();

  const [quteData, setQutoData] = useState({});
  const [eqData, setEqData] = useState({});
  const [customerData, setCustomerData] = useState(null);
  const [quRowData, setQuRowData] = useState([]);


  //document
  const [existingDocuments, setExistingDocuments] = useState([]);

  const [Eqslected, seEQSelect] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [followDate, setFollowDate] = useState("");
  const [validDate, setValidDate] = useState("");

  const [quotationStatus, setQuotationStatus] = useState("Draft");
  const [preparedBy, setPreparedBy] = useState("");
  const [isConverted, setIsConverted] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);

  const [emailData, setEmailData] = useState({
    to: "",
    subject: "",
    message: "",
  });

  const [followUps, setFollowUps] = useState([
    {
      current_date: dayjs().format("YYYY-MM-DD"),
      date: null,
      summary: "",
    },
  ]);




  const getLoggedInUser = async () => {
    try {
      const user = await UserService.getOmeUser();

      setPreparedBy(
        user?.name ||
        user?.full_name ||
        user?.username ||
        user?.uid ||
        "Admin"
      );
    } catch (error) {
      console.error(error);
    }
  };



  useEffect(() => {
    if (!qu_no) {
      navigate("/quotation");
      return;
    }

    getQuotationData(qu_no);
    getLoggedInUser();
  }, [qu_no, navigate]);

  const getQuotationData = async (id) => {
    try {
      const request = await QuotationService.getAllQuotationById(id);
      const quotation = request?.data?.quotation || {};
      const quotationData = request?.data?.quotation_data || [];

      setQutoData(quotation);
      setQuRowData(quotationData);
      setQuotationStatus(quotation?.quotation_status || "Draft");
      setIsConverted(!!quotation?.converted_to_project);

      const isManual = quotation?.eq_no === quotation?.qu_no;

      const savedSnapshot = {
        name: quotation.customer_name || "",
        company_name: quotation.customer_company || "",
        mobile_no: quotation.customer_mobile || "",
        contact_phone: quotation.customer_mobile || "",
        contact_whatsapp: quotation.customer_mobile || "",
        email: quotation.customer_email || "",
        contact_email: quotation.customer_email || "",
        gstin: quotation.customer_gstin || "",
        address: quotation.customer_address || "",
        location_city: quotation.customer_address || "",
        eq_description: quotation.requirement || "",
        summary: quotation.requirement || "",
        industry_type: quotation.business_type || "",
        business_type: quotation.business_type || "",
        no_of_users: quotation.no_of_users || "",
        number_of_employees: quotation.no_of_users || "",
        expected_start_date: quotation.expected_start_date || "",
        expected_go_live_date: quotation.expected_start_date || "",
        note: quotation.requirement_remarks || "",
        service_items: quotation.service_items || [],
        product_items: quotation.product_items || [],
      };

      if (isManual) {
        const cust = request?.data?.customer || {};
        setCustomerData(cust || null);
        setEqData(savedSnapshot);

        customerForm.setFieldsValue({
          name: savedSnapshot.name,
          mobile_no: savedSnapshot.mobile_no,
          address: savedSnapshot.address,
          note: savedSnapshot.note,
        });
      } else if (quotation?.eq_no) {
        const request2 = await EnquiryService.getEnquiryDetailsById(quotation.eq_no);
        const enq = request2?.status ? (request2.data || {}) : {};

        setEqData({
          ...enq,
          ...Object.fromEntries(
            Object.entries(savedSnapshot).filter(([_, v]) => v !== "" && v != null)
          ),
        });
        seEQSelect(false);
      }

      form.setFieldsValue({
        enquiry: quotation?.eq_no,
        quotationDate: quotation?.date ? dayjs(quotation.date) : null,
        n_follow_up: quotation?.n_follow_up
          ? dayjs(quotation.n_follow_up)
          : null,
      });

      setFollowDate(quotation?.expected_close_date || quotation?.n_follow_up || "");
      setValidDate(quotation?.valid_date || "");

      if (quotation?.date) {
        setSelectedDate(dayjs(quotation.date).format("YYYY-MM-DD"));
      }

      //document
      const documentsRes = await QuotationService.getQuotationDocuments(id);
      if (documentsRes?.status) {
        setExistingDocuments(documentsRes.data || []);
      }


      const fetchedFollowUps = quotation?.follow_ups;

      if (Array.isArray(fetchedFollowUps) && fetchedFollowUps.length > 0) {
        setFollowUps(
          fetchedFollowUps.map((item) => ({
            current_date: item.current_date
              ? dayjs(item.current_date).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),

            date: item.follow_date ? dayjs(item.follow_date) : null,

            summary: item.summary || "",

            follow_up_type: item.follow_up_type || null,

            follow_up_by: item.follow_up_by || "",
          }))
        );
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch quotation details");
    }
  };

  const handleGetDatabyEqid = async (id) => {
    try {
      const request = await EnquiryService.getEnquiryDetailsById(id);

      if (request.status) {
        setEqData(request.data || {});
        seEQSelect(false);
      } else {
        message.error(request.message);
      }
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch enquiry details");
    }
  };

  const toggleEdit = () => {
    seEQSelect((prev) => !prev);
  };

  const handleConvertToProject = () => {
    Modal.confirm({
      title: "Convert to Project?",
      content: "Are you sure you want to convert this quotation into a project?",
      okText: "Yes, Convert",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const res = await QuotationService.patchQuotation(quteData?.qu_no, {
            converted_to_project: true,
          });
          if (res.status) {
            setIsConverted(true);
            setQutoData((p) => ({ ...p, converted_to_project: true }));
            message.success("Converted to project");
          } else {
            message.error(res.message);
          }
        } catch (err) {
          console.error(err);
          message.error("Failed to convert quotation");
        }
      },
    });
  };

  const handleRemoveConversion = () => {
    Modal.confirm({
      title: "Remove Converted Status?",
      content: "Are you sure you want to remove the converted status from this quotation?",
      okText: "Yes, Remove",
      cancelText: "Cancel",
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          const res = await QuotationService.patchQuotation(quteData?.qu_no, {
            converted_to_project: false,
          });
          if (res.status) {
            setIsConverted(false);
            setQutoData((p) => ({ ...p, converted_to_project: false }));
            message.success("Conversion removed");
          } else {
            message.error(res.message);
          }
        } catch (err) {
          console.error(err);
          message.error("Failed to remove conversion");
        }
      },
    });
  };



  const handleAddFollowUp = () => {
    setFollowUps([
      ...followUps,
      {
        current_date: dayjs().format("YYYY-MM-DD"),
        date: null,
        summary: "",
      },
    ]);
  };

  const handleFollowUpChange = (index, field, value) => {
    const updated = [...followUps];
    updated[index][field] = value;
    setFollowUps(updated);
  };

  const handleCurrentDateChange = (index, value) => {
    const updated = [...followUps];
    updated[index].current_date = value
      ? dayjs(value).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
    setFollowUps(updated);
  };

  return (
    <>
      {msgConxt}

      <Card
        style={{
          borderRadius: 12,
          marginBottom: 12,
        }}
        bodyStyle={{ padding: 16 }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 18,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ArrowLeftOutlined
              style={{
                cursor: "pointer",
                fontSize: 18,
                color: "#111827",
              }}
              onClick={() => window.history.back()}
            />

            <Typography.Text
              style={{
                color: "rgba(11, 93, 148, 0.95)",
                fontWeight: 700,
                fontSize: 16,
              }}
            >
              Edit Quotation
            </Typography.Text>

            <Typography.Text style={{ color: "#9ca3af" }}>/</Typography.Text>

            <Typography.Text
              style={{
                color: "rgba(11, 93, 148, 0.95)",
                fontWeight: 800,
                fontSize: 16,
              }}
            >
              {quteData?.qu_no || qu_no}
            </Typography.Text>
          </div>

          <Space wrap>
            <Button onClick={() => window.history.back()}>
              Back
            </Button>


            <Button
              type="primary"
              icon={<MailOutlined />}
              style={{
                background: primaryColor,
                borderColor: primaryColor,
              }}
              onClick={() => editQuotationRef.current?.handleSendQuotationEmail()}
            >
              Send Email
            </Button>

            <Button
              icon={<FilePdfOutlined />}
              style={{
                borderColor: primaryColor,
                color: primaryColor,
              }}
              onClick={() =>
                editQuotationRef.current?.handlePrintInvoice(
                  quteData?.qu_no,
                  "professional"
                )
              }
            >
              Print PDF
            </Button>



          </Space>
        </div>

        <div
          style={{
            border: "1px solid #eef0f5",
            borderRadius: 10,
            padding: "5px 18px 18px",
            background: "#fff",
            marginBottom: 16,
          }}
        >
          <Typography.Title
            level={5}
            style={{
              margin: "0 0 18px",
              fontWeight: 600,
              fontSize: 16,
              color: "rgba(11, 93, 148, 0.95)",
            }}
          >
            Quotation Information
          </Typography.Title>

          <Form form={form} layout="vertical">
            <Row gutter={[24, 18]}>
              <Col xs={24} sm={12} md={5}>
                <InfoItem label="Quotation No" value={quteData?.qu_no || "-"} />
              </Col>

              <Col xs={24} sm={12} md={4}>
                <InfoItem
                  label="Revision No"
                  value={`R${quteData?.revision_no || 1}`}
                />
              </Col>

              <Col xs={24} sm={12} md={5}>
                <Form.Item
                  label={
                    <span
                      style={{
                        color: "#6b7280",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Quotation Date
                    </span>
                  }
                  name="quotationDate"
                  style={{ marginBottom: 0 }}

                  labelCol={{
                    style: {
                      paddingBottom: 2,
                    },
                  }}

                >
                  <DatePicker
                    size="small"
                    format="DD MMM YYYY"
                    style={{ width: "100%" }}
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(value) =>
                      setSelectedDate(
                        value ? dayjs(value).format("YYYY-MM-DD") : null
                      )
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={5}>
                <Form.Item
                  label={
                    <span
                      style={{
                        color: "#6b7280",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Valid Until
                    </span>
                  }
                  style={{ marginBottom: 0 }}

                  labelCol={{
                    style: {
                      paddingBottom: 2,
                    },
                  }}
                >
                  <DatePicker
                    size="small"
                    format="DD MMM YYYY"
                    style={{ width: "100%" }}
                    value={validDate ? dayjs(validDate) : null}
                    onChange={(value) =>
                      setValidDate(
                        value ? dayjs(value).format("YYYY-MM-DD") : null
                      )
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={5}>
                <InfoItem
                  label="Status"
                  value={
                    <span
                      style={{
                        background: "#e0edff",
                        color: "#2563eb",
                        padding: "6px 12px",
                        borderRadius: 6,
                        fontWeight: 700,
                      }}
                    >
                      {quotationStatus}
                    </span>
                  }
                />
              </Col>

              <Col xs={24} sm={12} md={5}>
                <InfoItem
                  label="Enquiry Reference"
                  value={
                    quteData?.eq_no && quteData?.eq_no !== quteData?.qu_no
                      ? quteData?.eq_no
                      : "-"
                  }
                />
              </Col>

              <Col xs={24} sm={12} md={4}>
                <InfoItem
                  label="Lead Source"
                  value={eqData?.eq_source || eqData?.lead_source || "-"}
                />
              </Col>

              <Col xs={24} sm={12} md={4}>
                <InfoItem
                  label="Prepared By"
                  value={preparedBy || "-"}
                />
              </Col>

              <Col xs={24} sm={12} md={5}>
                <InfoItem
                  label="Assigned To"
                  value={quteData?.assigned_to || eqData?.assigned_to || "-"}
                />
              </Col>

              <Col xs={24} sm={12} md={5}>
                <Form.Item
                  label={
                    <span
                      style={{
                        color: "#6b7280",
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      Expected Close Date
                    </span>
                  }
                  style={{ marginBottom: 0 }}

                  labelCol={{
                    style: {
                      paddingBottom: 2,
                    },
                  }}
                >
                  <DatePicker
                    size="small"
                    format="DD MMM YYYY"
                    style={{ width: "100%" }}
                    value={followDate ? dayjs(followDate) : null}
                    onChange={(value) =>
                      setFollowDate(
                        value ? dayjs(value).format("YYYY-MM-DD") : null
                      )
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>


        <ListEqData
          data={{
            ...eqData,
            ...quteData,
            eq_id:
              quteData?.eq_no && quteData?.eq_no !== quteData?.qu_no
                ? quteData?.eq_no
                : "",
          }}
          setEqData={setEqData}
          mode="edit"
        />






        <EditQuotationData

          ref={editQuotationRef}
          quteData={quteData}
          initialData={quRowData}
          validDate={validDate}
          Eqslected={!Eqslected}
          data={quteData?.qu_no}
          selectedDate={selectedDate}
          eqData={eqData}
          followDate={followDate}
          followUps={followUps}
          enquiryNo={quteData?.eq_no}
          quotationStatus={quotationStatus}
          preparedBy={preparedBy}
          assignedTo={eqData?.assigned_to || quteData?.assigned_to || eqData?.added_by || ""}

        />

        <Card
          style={{
            marginTop: 16,
            borderRadius: 12,

          }}
          bodyStyle={{
            padding: "12px 16px", // reduced from default 24px
          }}
        >
          <Row justify="space-between" align="middle" gutter={[16, 16]}>
            <Col>
              <Space>
                <Button icon={<ArrowLeftOutlined />} onClick={() => window.history.back()}>
                  Back
                </Button>

                <Button
                  onClick={async () => {
                    try {
                      const res =
                        await QuotationService.duplicateQuotation(
                          quteData?.qu_no
                        );

                      if (res.data.status) {
                        message.success("Quotation duplicated");

                        navigate("/quotation/edit", {
                          state: {
                            qu_no: res.data.data.qu_no,
                          },
                        });
                      } else {
                        message.error(res.data.message);
                      }
                    } catch (err) {
                      console.error(err);
                      message.error("Failed to duplicate quotation");
                    }
                  }}
                >
                  Duplicate
                </Button>
              </Space>
            </Col>

            <Col flex="auto">
              <div>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: 10,
                  }}
                >
                  Quotation Status Flow
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                  }}
                >
                  {[
                    "Draft",
                    "Reviewed",
                    "Sent",
                    "Viewed",
                    "Negotiation",
                    "Approved",
                    "Converted",
                  ].map((item) => (
                    <div
                      key={item}
                      onClick={() => setQuotationStatus(item)}
                      style={{
                        cursor: "pointer",
                        padding: "7px 14px",
                        borderRadius: 8,
                        border:
                          quotationStatus === item
                            ? `1px solid ${primaryColor}`
                            : "1px solid #e5e7eb",
                        background:
                          quotationStatus === item
                            ? "rgba(11, 93, 148, 0.10)"
                            : "#fafafa",
                        color:
                          quotationStatus === item
                            ? primaryColor
                            : "#6b7280",
                        fontWeight: 600,
                        fontSize: 12,
                      }}
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            <Col>
              <Space>
                <Button
                  icon={<FilePdfOutlined />}
                  style={{
                    borderColor: primaryColor,
                    color: primaryColor,
                  }}
                  onClick={() =>
                    editQuotationRef.current?.handlePrintInvoice(
                      quteData?.qu_no,
                      "professional"
                    )
                  }
                >
                  Print PDF
                </Button>
                <Button
                  style={{
                    borderColor: primaryColor,
                    color: primaryColor,
                  }}
                  onClick={() => editQuotationRef.current?.handleSave()}
                >
                  Update
                </Button>



                <Button
                  type="primary"
                  icon={<MailOutlined />}
                  style={{
                    background: primaryColor,
                    borderColor: primaryColor,
                  }}
                  onClick={() => editQuotationRef.current?.handleSendQuotationEmail()}
                >
                  Send Email
                </Button>
                {isConverted ? (
                  <Button
                    type="primary"
                    style={{
                      background: "#9ca3af",
                      borderColor: "#9ca3af",
                      color: "#f3f4f6",
                      opacity: 0.6,
                    }}
                    onClick={handleRemoveConversion}
                  >
                    Converted to Project
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{
                      background: primaryColor,
                      borderColor: primaryColor,
                    }}
                    onClick={handleConvertToProject}
                  >
                    Convert to Project
                  </Button>
                )}
              </Space>
            </Col>
          </Row>
        </Card>
      </Card>

      <Modal
        title="Send Quotation Email"
        open={emailModalOpen}
        onCancel={() => setEmailModalOpen(false)}
        okText="Send Email"
        onOk={async () => {
          try {
            const res = await QuotationService.sendQuotationEmail(
              quteData?.qu_no,
              emailData
            );

            if (res.status) {
              message.success(res.message);
              setEmailModalOpen(false);
            } else {
              message.error(res.message);
            }
          } catch (error) {
            console.error(error);
            message.error("Failed to send email");
          }
        }}
      >
        <Form layout="vertical">
          <Form.Item label="To">
            <Input
              value={emailData.to}
              onChange={(e) =>
                setEmailData({ ...emailData, to: e.target.value })
              }
            />
          </Form.Item>

          <Form.Item label="Subject">
            <Input
              placeholder="Enter email subject"
              value={emailData.subject}
              onChange={(e) =>
                setEmailData({ ...emailData, subject: e.target.value })
              }
            />
          </Form.Item>

          <Form.Item label="Message">
            <Input.TextArea
              rows={6}
              placeholder="Write email message"
              value={emailData.message}
              onChange={(e) =>
                setEmailData({ ...emailData, message: e.target.value })
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </>

  );
};

const InfoItem = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      minHeight: 52,
    }}
  >
    <div
      style={{
        color: "#6b7280",
        fontSize: 12,
        fontWeight: 600,
        marginBottom: 2,
      }}
    >
      {label}
    </div>

    <div
      style={{
        color: "#111827",
        fontSize: 14,
        fontWeight: 700,
        lineHeight: 1.5,
      }}
    >
      {value || "-"}
    </div>
  </div>

);

export default EditViewQuotation;